module.exports = __webpack_public_path__ + "img/67.d4fd997f.jpeg";